/* eslint-disable camelcase */
/* global ChoiceOption */
import _ from 'lodash';
import {
  baseURL, createAChip, defaultFilters,
  storageKey, generateFiltersFromParamsObject,
} from '.';
import {
  ColumnType, SystemTypeEnum, FilterChip, Client,
} from '../column-filter.types';
import LocalStoragePreferences from '../../../../utils/local-storage-preferences';

interface ValidFilter {
  validKey: string;
}

const storage = new LocalStoragePreferences();

const getValidCols = (cols: Record<string, any>[]): ValidFilter[] => cols.map(
  (col) => ({ validKey: col.accessor }),
);

const storedChips = ((type: SystemTypeEnum) => {
  const chips = storage.getUserChips(`${type}-${storageKey}`);

  if (!chips) {
    return null;
  }

  return chips;
});

export async function buildFiltersFromURLParams(
  api: Client, cols: ColumnType, id: string, type: SystemTypeEnum,
): Promise<FilterChip[]> {
  const validFilters = getValidCols(cols);
  const newFilters: FilterChip[] = [];

  const queryObject = Object.fromEntries(new URLSearchParams(window.location.search));

  let defaults: FilterChip[] = [];

  if (Object.keys(queryObject).length) {
    defaults = await generateFiltersFromParamsObject(api, id, type, queryObject);
  } else {
    defaults = storedChips(type) ?? defaultFilters[type];

    if (defaults.length) {
      parameterizeFilters(cols, defaults, type);
    }
  }

  defaults.forEach((option) => {
    const keyFound = validFilters.find((filter: any) => filter.validKey === option.key);

    if (keyFound) {
      const newChip: FilterChip | null = createAChip(
        cols,
        option.values as ChoiceOption[],
        option.key,
      );

      if (newChip) {
        newFilters.push(newChip);
      }
    }
  });

  return _.uniqBy(newFilters, 'label');
}

export const parameterizeFilters = (
  cols: Record<string, any>[],
  columnFilters: FilterChip[],
  type: string,
) => {
  if (columnFilters.length === 0) {
    window.history.replaceState(null, document.title, baseURL[type]);

    return;
  }

  const validFilters = getValidCols(cols);
  const params: Array<string> = [];

  columnFilters.forEach(({ key, values }) => {
    const keyFound = validFilters.find(
      (filter: any) => filter.validKey === key,
    );

    if (keyFound) {
      const paramValue = (values as ChoiceOption[])?.map((opt) => `%27${opt.value}%27`);

      params.push(`${keyFound.validKey}=${paramValue}`);
    }
  });

  window.history.replaceState(null, document.title, `?${params.join('&')}`);
};
